import React from 'react'
import images from '../../constants/images';
import './OneColumnB.css';


const OneColumnB = ({ titleTwo, subtitle, subheader, paragraph }) => {
    


    return (
        <div >
            <div >
                <h1 className="headtext__roboto"> { titleTwo } </h1>
                <h3 className="subheadtext__roboto"> { subtitle } </h3>
                <h4 className="h4__roboto"> { subheader } </h4>
                <img src={ images.pitch } alt="pitch" className="pitch__img" />
                <p className="p__opensans"> { paragraph } </p>
               
            </div>
        </div>
    )
}

export default OneColumnB